module.exports = __webpack_public_path__ + "static/media/angle-down.d7a5eb38.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/angle-down.svg
// module id = 160
// module chunks = 0